export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let redirect = false;

      const idRouteParam = parseInt(to.params.id, 10);
      const { memorial } = vm.get();

      if (!memorial) {
        redirect = true;
      } else if (_.isInteger(idRouteParam) && idRouteParam !== memorial.id) {
        redirect = true;
      } else if (_.isString(idRouteParam) && to.params.id !== memorial.unique_key) {
        redirect = true;
      }

      if (redirect) {
        return next({ name: 'memorial.show', params: { id: to.params.id } });
      }

      return next();
    });
  },
};



// WEBPACK FOOTER //
// ./src/mixins/MemorialGuard.js